<script>
  import { onMount } from 'svelte';
  import { MDCFormField } from '@material/form-field';
  import { MDCRadio } from '@material/radio';
  import { t9n } from '../translate.js';
  import { TS } from '../../config/translation-keys.js';

  // component options  ------------------------------------------------------ //

  export let items;
  // internal variables ------------------------------------------------------ //

  let pp_trans;
  let expires_label;
  let radio;
  let formField;

  // utility functions -------------------------------------------------------- //

  const init_radio = () => {
    radio = new MDCRadio(document.querySelector('.mdc-radio'));
    formField = new MDCFormField(document.querySelector('.mdc-form-field'));
  };

  const get_id = index => {
    return 'radio-' + index;
  };

  const select_radio = index => {
    if (!items[index] || !items[index].is_enabled) return;
    for (let i = 0; i < items.length; i++) {
      if (i === index) {
        items[i].is_selected = true;
      } else {
        items[i].is_selected = false;
      }
    }
  };

  $: {
    // chip_unassigned = t9n(TS.TABLE_CHIP_UNASSIGNED);
    pp_trans = t9n(TS.NEW_ORDER_NOT_EN_PP);
    expires_label = t9n(TS.CARDS_LIST_EXPIRES_LABEL);
  }
  onMount(init_radio);
</script>

{#each items as item, i}
  <div class="mdc-form-field">
    <div class="mdc-radio">
      <input
        disabled={!item.is_enabled}
        class="mdc-radio__native-control"
        type="radio"
        id={get_id(i)}
        name="radios"
        checked={item.is_selected}
        on:click={() => select_radio(i)} />

      <!--            {#if i === 0}-->
      <!--                -->
      <!--            {:else}-->

      <!--                <input-->
      <!--                        disabled={!item.is_enabled}-->
      <!--                        class="mdc-radio__native-control"-->
      <!--                        type="radio"-->
      <!--                        id={get_id(i)}-->
      <!--                        name="radios"-->
      <!--                        on:click={() => select_radio(i)}>-->
      <!--            {/if}-->

      <div class="mdc-radio__background">
        <div class="mdc-radio__outer-circle" />
        <div class="mdc-radio__inner-circle" />
      </div>
      <div class="mdc-radio__ripple" />
    </div>
    <label style=' font-size: 16px;' for={get_id(i)}>
      {item.name}
      {#if item.is_enabled === false && i === 1}{pp_trans}{/if}
    </label>
  </div>
  {#if item.expiry_year}
  <p style='margin-left: 43px;
      font-size: 12px;
      margin-top: -7px;
      color: gray;'>
    {expires_label}: {item.expiry_month}/{item.expiry_year}
  </p>
  {/if}
  <p />
{/each}

<style>

</style>
